import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import errorMsg from "../assets/images/network-error.svg";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 80vh;
`;
const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const HomeBtn = styled.button`
  margin-top: 15px;
  font-size: 20px;
  width: 300px;
  background: #FF4343;
  color: white;
  padding: 10px;
  border-radius: 10px;
  &:hover {
    background: #FF7373;
  }
`;

const NetworkErrorPage = () => {
  /* const location = useLocation();
  let title = location.search
    ? location.search.split("statusCode=")[1].split("&")[0]
    : null;
  let description = location.search
    ? location.search.split("errorMsg=")[1].replaceAll("%20", " ")
    : null; */

  return (
    <Container>
      <InnerContainer>
        <img src={errorMsg} alt="" />
        <Link to={"/"}>
          <HomeBtn>확인 &rarr;</HomeBtn>
        </Link>
      </InnerContainer>
    </Container>
  );
};

export default NetworkErrorPage;
